
import {initWebComponent} from "@/helpers/web-component-helper";
import {loadLinkedData} from "@/helpers/layer/info/layer-info-info-linked-data-helper";

export class LayerInfoInfoItemLinkedDataButtonComponent extends HTMLElement {
    constructor(){
        super();

        const domainID = this.getAttribute('data-domain-id')
        const presentationID = this.getAttribute('data-presentation-id')
        let featureID = this.getAttribute('data-feature-id')
        const index = this.getAttribute('data-index')

        const template = document.createElement('template');

        template.innerHTML = `<button class="btn btn-sm btn-outline-secondary icon-btn text-transform-none popper-header" href="#">
                          <span class="fa fa-info"></span>
                          <div class="popper-tooltip" role="tooltip" data-popper-placement="top">
                             Meer informatie
                            <div class="arrow" data-popper-arrow=""></div>
                          </div>
                    </button>`

        initWebComponent(this, template)

        this.addEventListener('click', () => {

            if(window.attributeItems && window.attributeItems[0]) {
                const attributeItem = window.attributeItems[0].find(attributeItem => attributeItem.featureInfo.LayerName === 'zakelijkGerechtigden')
                if(attributeItem) {
                    featureID = window.attributeItems[0][0].featureInfo.records[0].featureid + '/' + featureID

                    // featureID = featureID.replace('bijbehorendeAppartementsrechten.bag:', '')
                    // featureID = featureID.replace('kadastraalonroerendezaken.bag:', '')
                }

            }


            loadLinkedData(domainID, presentationID, featureID, index)
        })
    }
}

